/* global googletag, gtm, Cookies, mainLocalized */
import Cookies from 'js-cookie';
import Digest from 'digest-js';
import CancellablePromise from './components/cancellable-promise';
import {v4 as uuidv4} from 'uuid';

var hmUtils = {
	helpersVersion : '0.0.1',
	setDFPTarget : ( key, value ) => {
		if ( googletag && value ) {
			let formattedValue = Array.isArray( value )
				? value.map( String )
				: String( value );
			googletag.cmd.push( function () {
				googletag.setConfig( {
					targeting: formattedValue
				} );
			} );
		}
	},
	handleExternalLinks: () => {
		document.querySelectorAll('a[href^="http"]').forEach((a) => {
			if (window.location.hostname !== new URL(a.href).hostname) {
				if (!a.hasAttribute('target')) {
					a.setAttribute('target', '_blank');
				}
				if (!a.hasAttribute('rel')) {
				    a.setAttribute('rel', 'noopener');
				} else {
					let relAttr = a.getAttribute('rel');
					if ( !relAttr.includes('noopener')) {
					    relAttr = relAttr + ' '+'noopener';
					}
					a.setAttribute('rel', relAttr);
				}
			}
		});
	},
	/**
	 * Pushes the specified data object to the global `dataLayer` array.
	 * If the `dataLayer` array does not exist on the `window` object, it initializes it as an empty array.
	 *
	 * @param {Object} data - The data object to be pushed to the `dataLayer`.
	 */
	setDataLayerTarget : ( data ) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( data );
	},
	/**
	 * Get user data from cookie using js-cookie
	 */
	getUserData : () => {
		const data = Cookies.get( 'globalActData' );

		if ( ! data ) {
			return false;
		}

		return JSON.parse( decodeURIComponent( data ) );
	},
	/**
	 * Get value from localStorage
	 * TODO make localStorage library global or add to helpers
	 */
	retrieveLocalStorage : function ( dataID ) {
		if ( typeof( Storage ) !== 'undefined' ) {
			if ( window.localStorage.getItem( dataID ) ) {
				return( window.localStorage.getItem( dataID ) );
			}
		}
	},
	/**
	 * Set custom user targeting
	 */
	setUserTargeting : () => {
		let userData = typeof hmUtils !== 'undefined' && hmUtils.getUserData ? hmUtils.getUserData() : '';
		let medicalData = userData && userData.medicalData;
		let targeting = {};
		targeting['log']  = '0';
		if ( userData && Object.prototype.hasOwnProperty.call(  userData, 'subscriber' ) ) {
			const hashedEmailId = userData.subscriber.email ? hmUtils.sha256( userData.subscriber.email ) : '';
			targeting['log']  = '1';
			targeting['subid']  = userData.subscriber.subscriberId.toString();
			targeting['usrc']  = 'haymarket';
			targeting['eid']  = hashedEmailId;
		}
		/* custom event called setGAMTargeting is triggered to pass targeting data to ad stack and set gam targeting */
		let targetingEvent = new CustomEvent( 'setGAMTargeting', {'detail' : targeting } );
		document.dispatchEvent( targetingEvent );
	},
	headerLoginState : () => {
		if ( ! window.hmOIDCRegistration ) {
			let loginNavButtons = document.querySelectorAll( '.sso-buttons' );
			if ( document.getElementsByClassName( '-business' ).length ) { // For BC cluster
				loginNavButtons = document.querySelector( '.login-nav-buttons' );
			}
			//Run below code only when logged in to WP
			if ( document.body.classList.contains( 'logged-in' ) ) {
				const template = document.getElementById('template-login-buttons');
				if ( template ) {
					const templateHTML = template.innerHTML;
					loginNavButtons.forEach((node, index) => {
						node.classList.add('logged-in');
						node.innerHTML = templateHTML;
					});
				}
				document.dispatchEvent( new CustomEvent( 'hideSubscriptionNav', {  } ) );
			}
			// To handle Business cluster //
			const template = document.getElementById( 'template-login-nav' );
			if ( template ) {
				const templateHTML = template.innerHTML;
				loginNavButtons.innerHTML = templateHTML;
			}
			/** Run the below code when CF is not working.proxyEnabled const defined by CF. */
			if ( typeof proxyEnabled === 'undefined' ) {
				document.querySelectorAll('.buttonlogout').forEach(logout => {
					logout.addEventListener('click', hmUtils.logoutUser);
				});
			}
		}

	},
	logoutUser : ( e ) => {
		e && e.preventDefault();

		document.cookie = 'globalAct' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		document.cookie = 'globalActData' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		document.cookie = 'globalActStatus' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		document.cookie = 'hmDisqusAuth' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

		hmUtils.xhrGET( mainLocalized.sso.ssoLogout, false, { withCredentials: true } )
			.then( () => window.location.href = mainLocalized.home_url )
			.catch( error => console.error( error ) ); // eslint-disable-line
	},

	/**
	 * Set dataLayer values
	 */
	setUserDataLayer : () => {
		const user = hmUtils.getUserData();

		const isSubscriber = user && user.hasOwnProperty( 'subscriber' );
		const isUser = user && user.hasOwnProperty( 'medicalData' );
		const fullAccount = hmUtils.isFullUser();

		// Set GTM dataLayer targeting.
		let urlDecode = hmUtils.urlDecode;
		let data = {};
		data['User.LoggedIn'] = fullAccount ? 'true' : 'false';
		data['User.Eid'] = isSubscriber ? hmUtils.sha256( user.subscriber.email ) : '';
		data['User.SubscriberId'] = isSubscriber ? user.subscriber.subscriberId.toString() : '';
		data['User.JobTitle'] = user && user.hasOwnProperty( 'business' ) && user.business.jobTitle ? urlDecode( user.business.jobTitle ) : '';
		data['User.CampaignCodes'] = isSubscriber && Cookies.get( 'adcpn2' ) ? Cookies.get( 'adcpn2' ) : '';
		data['User.IsHaymarket'] = isSubscriber ? 'true' : 'false';
		hmUtils.setDataLayerTarget( data );
	},
	cleanTargetingValue : ( value ) => {
		let strippedValue = value.replace( /["'=!+#*~;^()<>[\]{},&]/g, '' ).split( ' ' ).join( '_' );
		return strippedValue;
	},
	isFullUser : () => {
		const user = hmUtils.getUserData();
		// dpt-578 - removing wp admin login as definition of isFullUser
		return ( Cookies.get( 'globalActStatus' ) === 'full' && user && user.hasOwnProperty( 'subscriber' ) );
	},
	isAUser : () => {
		if ( window.hmOIDCRegistration ) { // check if the new reg is active //
			return window.Cookies && window.Cookies.get( 'user_profile_id' );
		}
		return Cookies.get( 'globalActStatus' ) === 'full' || !!Cookies.get( 'globalActData' );
	},
	urlDecode : ( str ) => {
		return decodeURIComponent( str.replace( /\+/g, ' ' ) );
	},
	toHexString : ( byteArray ) => {
		return Array.from( byteArray, function( byte ) {
			return ( '0' + ( byte & 0xFF ).toString( 16 ) ).slice( -2 );
		} ).join( '' );
	},
	sha256 : ( str ) => {
		var dg = new Digest.SHA256();
		var buf = dg.digest( str );
		var byteArray = new Uint8Array( buf );
		return hmUtils.toHexString( byteArray );
	},
	/**
	 * Get user data using document.cookie
	 */
	getCookieUserData : ( ) => {
		if ( Cookies.get( 'globalActData' ) && Cookies.get( 'globalActStatus' ) && Cookies.get( 'globalActStatus' ) == 'full' ) {
			let userCookie = document.cookie.replace( /(?:(?:^|.*;\s*)globalActData\s*\=\s*([^;]*).*$)|^.*$/, "$1" ); // eslint-disable-line
			let userData = JSON.parse( decodeURIComponent( userCookie ) );
			return userData;
		}
		return null;
	},
	/**
	 * Make a GET XHR request using `XMLHttpRequest`
	 * @param  string  url    Request URL
	 * @param  Object params  Query Params for the request
	 * @return CancellablePromise         A cancellable XHR promise
	 */
	xhrGET : ( url, params = false, options = {} ) => {
		if ( params ) {
			url += '?' + hmUtils.getQueryString( params );
		}
		options.method = 'GET';
		options.url = url;
		return hmUtils.xhrRequest( options );
	},
	/**
	 * Make a POST XHR request using `XMLHttpRequest`
	 * @param  string  url    Request URL
	 * @param  Object params  Query Params for the request
	 * @return CancellablePromise         A cancellable XHR promise
	 */
	xhrPOST : ( url, params = false, options = {} ) => {
		options.method = 'POST';
		options.url = url;
		options.params = JSON.stringify( params );
		options.headers = {...options.headers, ...{'Content-type': 'application/json'}};
		return hmUtils.xhrRequest( options );
	},
	/**
	 * Make a XHR request using `XMLHttpRequest`
	 * @param  Object options Options for the request
	 * Allowed options are `method`,`headers` and `params`
	 * @return CancellablePromise         A cancellable XHR promise
	 */
	xhrRequest : ( options ) => {
		return new CancellablePromise( ( resolve, reject, onCancel ) => {
			var xhr = new XMLHttpRequest();

			// Abort the XHR request on Promise.cancel
			onCancel( xhr.abort.bind( xhr ) );

			xhr.open( options.method, options.url );
			xhr.onload = function () {
				if ( this.status === 200 ) {
					const contentType = xhr.getResponseHeader( 'Content-Type' );
					if ( contentType && contentType.indexOf( 'application/json' ) !== -1 && xhr.responseText.length ) {
						try {
							resolve( JSON.parse( xhr.responseText ) );
						} catch ( err ) {
							console.error( err ); // eslint-disable-line
							resolve( xhr.responseText );
						}
					} else {
						resolve( xhr.responseText );
					}
				} else {
					reject( {
						status      : this.status,
						statusText  : xhr.statusText,
						responseText: xhr.responseText || ''
					} );
				}
			};
			xhr.onerror = function () {
				reject( {
					status    : this.status,
					statusText: xhr.statusText
				} );
			};

			if ( options.headers ) {
				Object.keys( options.headers ).forEach( function ( key ) {
					xhr.setRequestHeader( key, options.headers[ key ] );
				} );
			}

			let params = options.params;
			// We'll need to stringify if we've been given an object
			// If we have a string, this is skipped.
			if ( params && typeof params === 'object' ) {
				params = hmUtils.getQueryString( params );
			}

			if ( options.withCredentials ) {
				xhr.withCredentials = true;
			}

			xhr.send( params );
		} );
	},
	/**
	 * Serialize params to a GET query string
	 * @param  Object params Query Params for the request
	 * @return string        Serialized query string
	 */
	getQueryString : ( params ) => {
		return Object.keys( params ).map( key => encodeURIComponent( key ) + '=' + encodeURIComponent( params[ key ] ) ).join( '&' );
	},
	/**
	 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
	 * The function will be called after it stops being called for N milliseconds.
	 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
	 *
	 * @author https://davidwalsh.name/javascript-debounce-function
	 *
	 * @param {*Function} func The function to debounce.
	 * @param {Interger} wait Time to wait between calls. (default 300 ms)
	 * @param {Boolean} immediate Call function at leading edge instead of trailing.
	 */
	debounce : function ( func, wait = 300, immediate ) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if ( !immediate ) func.apply( context, args );
			};
			var callNow = immediate && !timeout;
			clearTimeout( timeout );
			timeout = setTimeout( later, wait );
			if ( callNow ) func.apply( context, args );
		};
	},
	/**
	 * throttle is used to optimize continuous user events like resizing and scrolling
	 * @param cb
	 * @param delay
	 * @returns {(function(...[*]): void)|*}
	 */
	throttle : ( cb, delay ) => {
		let wait = false;
		let storedArgs = null;
		function checkStoredArgs () {
			if ( storedArgs == null ) {
				wait = false;
			} else {
				cb( ...storedArgs );
				storedArgs = null;
				setTimeout( checkStoredArgs, delay );
			}
		}
		return ( ...args ) => {
			if ( wait ) {
				storedArgs = args;
				return;
			}
			cb( ...args );
			wait = true;
			setTimeout( checkStoredArgs, delay );
		};
	},
	/**
	 * `DOMContentLoaded` event, checks for document.readyState
	 * `DOMContentLoaded` is not fired if the event is added after it's fired
	 * @param  callback   function
	 */
	onDomContentLoad : ( callback ) => {
		if ( typeof callback !== 'function' ) {
			return;
		}

		if ( document.readyState == 'loading' ) {
			document.addEventListener( 'DOMContentLoaded', callback );
		} else {
			callback();
		}
	},
	/**
	 * Return query param value by name
	 *
	 * @param name
	 * @param url
	 * @returns {*}
	 */
	getParameterByName : ( name, url ) => {
		if ( !url ) url = window.location.href;
		name = name.replace( /[[\]]/g, '\\$&' );
		const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)', 'i' ),
			results = regex.exec( url );

		if ( !results ) {
			return '';
		}
		if ( !results[ 2 ] ) {
			return '';
		}
		return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
	},
	/**
	 * Checks if page is article.
	 */
	isArticle : () => {
		const
			body      = document.querySelector( 'body' ),
			container = document.querySelector( '.post-container' );

		if ( ! body.classList.contains( 'single-post' ) || ! container ) {
			return false;
		}

		return true;
	},
	/**
	 * Check if user is a medical user
	 */
	isMedicalLogin : ( ) => {
		let userData = hmUtils.getCookieUserData( );
		if ( userData && userData.medicalData ) {
			return true;
		}
		return false;
	},
	/**
	 * redirect page if user is not logged in
	 */
	redirectAnonymousUsers : ( ) => {
		if ( ! hmUtils.isFullUser() ) {
			window.location.href = window.mainLocalized && window.mainLocalized.home_url;
		}
	},
	/**
	 *  Check for email hash in newsletter URL.
	 *  Check if user data email is available and generate hash.
	 *  Check if either one of them is available and return it.
	 */
	getHashedEmail : ( ) => {
		const URLEmail = hmUtils.getParameterByName( 'email_hash' );
		const userData = Cookies.get( 'globalActData' );
		const userEmail = userData ? JSON.parse( userData ).subscriber.email : '';
		const hashedEmail = userEmail ? hmUtils.sha256( userEmail ) : '';
		const email = URLEmail ? URLEmail : hashedEmail;
		return email;
	},
	getBrowserName : function (  ) {
		var ua = navigator.userAgent,
			tem,
			M = ua.match( /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i ) || [];
		if ( /trident/i.test( M[ 1 ] ) ) {
			tem = /\brv[ :]+(\d+)/g.exec( ua ) || [];
			return 'IE ' + ( tem[ 1 ] || '' );
		}
		if ( M[ 1 ] === 'Chrome' ) {
			tem = ua.match( /\b(OPR|Edge)\/(\d+)/ );
			if ( tem != null ) {
				return tem.slice( 1 ).join( ' ' ).replace( 'OPR', 'Opera' );
			}
		}
		M = M[ 2 ] ? [ M[ 1 ], M[ 2 ] ] : [ navigator.appName, navigator.appVersion, '-?' ];
		if ( ( tem = ua.match( /version\/(\d+)/i ) ) != null ) {
			M.splice( 1, 1, tem[ 1 ] );
		}
		return M.join( ' ' );
	},
	isMobile : function ( ) {
		return Math.min( window.screen.width, window.screen.height ) < 640 || navigator.userAgent.indexOf( 'Mobi' ) > -1;
	},
	isMobileBrowserSize: function() {
		return window.innerWidth < 768 || navigator.userAgent.indexOf( 'Mobi' ) > -1;
	},
	isMobileNavigation : function ( ) {
		// desktop nav is required on devices 768px wide and over
		// checking on desktops if screen height is tiny - accommodates editorial use
		// checking here so that phones in landscape over 768px will still have mobile nav
		return window.screen.width < 768 || ( window.screen.width > 1260 && window.screen.height < 768 ) || (window.screen.width > 811 && window.screen.width < 916 && window.screen.orientation.type === 'landscape-primary');
	},
	truncateNPIHash( data ) {
		const sha256length = 12; // default sha256 length is 64 characters
		if ( sha256length < 64 ) {
			return( data.substring( 0, sha256length ) );
		}
		return( data );
	},
	generateUUID() {
		// returns a Universally Unique IDentifier
		return uuidv4();
	},
	/**
	 * Retrieve user's selection from OptanonConsent cookie.
	 * groups is a substring with value like C0001:1,C002:1, where C0001 represent the ID of a category(Strictly necessary Cookies) and 1/0 represents
	 * user's selection where 1 means user has opted in.
	 * Check if OneTrust cookie is present and user has opted out of OneTrust Targeting Category. C0004 is the ID of Targeting Category.
	 */
	hasUserEnabledOneTrust() {
		let isOneTrustSelected = true;
		if ( typeof window.OptanonActiveGroups !== 'undefined' && ! window.OptanonActiveGroups.includes( 'C0004' ) ) {
			isOneTrustSelected = false;
		}
		return isOneTrustSelected;
	},
	/**
	 * Get CPN from either URL or adcpn2 cookie if present
	 * @return {string}
	 */
	getCPNValue() {
		return hmUtils.getUrlAndCookieValue( 'cpn', 'adcpn2' );
	},
	/**
	 * Get oracle cookie ID
	 * @return {*|string|string}
	 */
	getOracleCookieId() {
		const oracleCookie = window.Cookies && window.Cookies.get( 'ORA_FPC' );
		let oracleCookieID = oracleCookie ? oracleCookie.split( 'id=' ) : '';
		if( oracleCookieID.length > 1 ) {
			return oracleCookieID[1];
		}
		return oracleCookieID;
	},
	/**
	 *  Get navigation API performance metrics
	 *  Reference : https://blog.shimin.io/measure-web-performance-with-navigation-timing-api/
	 * @return {any}
	 */
	getNavigationAPIPerfEntries() {
		const perfEntries = performance.getEntriesByType("navigation");
		const [p] = perfEntries;
		return p.toJSON();
	},
	/**
	 * redirect page if user is logged in(copied from the legacy theme)
	 */
	redirectLoggedInUsers() {
		if (hmUtils.isFullUser()) {
			window.location.href = window.mainLocalized && window.mainLocalized.sso && window.mainLocalized.sso.accountUrl;
		}
	},
	/**
	 * Retrieves the combined value from a URL parameter and a cookie
	 * by ensuring unique values are maintained.
	 *
	 * @param {string} key - The key to retrieve the value from URL query parameters.
	 * @param {string} cookieName - The name of the cookie to retrieve the value from.
	 * @return {string} The updated or existing cookie value after combining it
	 *                  with the cleaned URL parameter value, if present.
	 */
	getUrlAndCookieValue( key = '', cookieName = '' ) {
		const params = new URLSearchParams( window.location.search );
		const urlParam = params.get( key );
		let cookieVal = Cookies.get( cookieName );

		if ( urlParam ) {
			const cleanedParam = window.hmUtils.cleanTargetingValue( urlParam );
			const cookieValues = cookieVal ? cookieVal.split( ',' ) : [];
			if ( ! cookieValues.includes( cleanedParam ) ) {
				cookieValues.push( cleanedParam );
				cookieVal = cookieValues.join( ',' );
			}
		}
		return cookieVal ?? '';
	},
	getUserProfileData() {
		const userCookie = window.Cookies?.get( 'user_profile' );
		if ( ! userCookie ) {
			return false;
		}
		try {
			return JSON.parse( decodeURIComponent( userCookie ) );
		} catch ( error ) {
			console.error( 'Error parsing user profile cookie:', error );
			return false;
		}
	},
	/**
	 * Retrieves the details of a known user based on ISM (Identity and Security Management) data.
	 *
	 * @return {Promise<Object>} A Promise that resolves to an object containing the result of the operation.
	 * How to use it? : const response = await window.hmUtils.getKnownUserDetails();
	 * We have used closure to enforce caching so that this promise is initialized only once.
	 */
	getKnownUserDetails: ( ()  => {
		let cachedPromise = null;
		return function () {
			if ( cachedPromise ) {
				return cachedPromise;
			}
			cachedPromise = new Promise( ( resolve, reject ) => {
				const rejectWithError = (reason) => {
					resolve({
						success: false,
						data: [],
						error: `Could not retrieve user details - ${reason}`
					});
				};
				try {
					const ismData = window.ismData;
					if (!ismData?.enabled) {
						return rejectWithError('ISM is not enabled');
					}
					ismData.cmd = ismData.cmd || [];
					ismData.cmd.push( function() {
						try {
							const vendorData = ismData.getTargetingInfo();
							const userData = {
								npiVerified: !!vendorData?.npi,
								firstName: vendorData?.userDetails?.firstName || '',
								lastName: vendorData?.userDetails?.lastName || '',
								specialty: vendorData?.sprText || vendorData?.specialty || '',
								profession: vendorData?.profession || '',
								npi: vendorData?.npi
							};
							resolve({ success: true, data: userData, error: null });
						} catch ( e ) {
							rejectWithError( e );
						}
					} );
				} catch ( e ) {
					rejectWithError( e );
				}
			});
			return cachedPromise
		};
	})()
};


window.hmUtils = hmUtils;

hmUtils.getHashedString = async function ( rawString ) {
	const encoder = new TextEncoder();
	const data = encoder.encode( rawString );
	const hashBuffer =  await window.crypto.subtle.digest( 'SHA-256', data );
	const hashArray = Array.from( new Uint8Array( hashBuffer ) );
	return hashArray.map( b => b.toString( 16 ).padStart( 2, '0' ) ).join( '' );
}
window.Cookies = Cookies;
